import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";

import { css } from "styled-components";

logoStyles.image = mergeToNew(logoStyles.image, {
    width: 12,
    css: css`
        width: 100%;
        max-height: 120px;
        img {
            height: auto;
            width: auto;
        }
    `,
});

logoStyles.container = mergeToNew(logoStyles.container, {
    css: css`
        width: 100%;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
});
